import { functions } from "../data/data"

export default function StepAnalysis( { sourcecode } ){

    let txt = sourcecode.split("\n").map(line => line.trim());

    let data = [];
    let a;
    let b;
    let cnt;

    for(let i = 0; i < txt.length; i++){ //for all the words, 

        if(txt[i].startsWith('//')){ //if it's a match,
        
        data.push({
            index: i,//original line index
            content: txt[i].slice(2),
        }); 
        }
    }

    //CALCULATE DIFF (LENGTH, BAR, VOL..)
    for(let i = 0; i < data.length; i++){
        //cnt = b - a - 1 (to get numbers between a and b, excluding a and b)
        a = data[i].index;
        
        if(i < data.length - 1){
            b = data[i + 1].index;
        }else{ //for the last step,
            b = txt.length - 1;
        }
        
        cnt = b - a - 1;
        
        //ADD THAT TO THE ARRAY
        data[i].cnt = cnt;
    }

    return(
        <div key = { sourcecode.id }>
            <h3>Step Analysis ({ data.length }) :</h3>
            <p className = "meta3" style = { { padding : "8px 0px"} }>lines · step name</p>

            { data.map( ( item, index ) => (
                <div key = { index } style = { { display : "flex", alignItems : "center", marginBottom : "4px" } }>
                    <div style = { { display : "flex", alignItems : "center", gap : "8px", width : "48px" } }>
                        <span style = { { width : "16px", height : `${item.cnt}px`, backgroundColor : "var(--black16)" } }/>
                        <p className = "meta3">{ item.cnt }</p>
                    </div>
                    <p className = "meta2">· { item.content }</p>
                </div>
            ))}
        </div>
    )
}